//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// dto_for_DV1_UpdateTagsForResourceConcernCategory_Request
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class dto_for_DV1_UpdateTagsForResourceConcernCategory_Request {

    resource_category_tag_id = null
    resource_concern_category_id = null
    tag_ids_add = []
    tag_ids_remove = []


}